// extracted by mini-css-extract-plugin
export default {"form":"Login_form__rQ1wj","wrapper":"Login_wrapper__b70+O","link":"Login_link__Hpl1N","button":"Login_button__-R4Ds"};